import * as React from 'react';
import { useStore } from 'zustand';
import { PredicateStoreContext } from '../context';

export const usePredicateStoreAddPredicatePart = () => {
    const { store } = React.useContext(PredicateStoreContext);
    if (!store) throw new Error('Missing PredicateStoreContext.Provider in the tree');
    const addPredicatePart = useStore(store, (s) => s.addPredicatePart);

    return addPredicatePart;
};
